import React, { Component } from 'react';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar/index';
import { ReloadOutlined } from '@ant-design/icons';
import { Table, Modal, DatePicker, Switch, Button, Tooltip } from 'antd';
import { connect } from 'react-redux';
import TextTruncate from 'react-text-truncate';
import qs from 'qs';
import moment from 'moment';
import _ from 'lodash';
import { checkPermission } from '@/utils/permission';
import { cleanObject, isValidDate, stripHtml } from '@/utils/helpers';
import BaseSelect from '@/components/Elements/BaseSelect';
import PostForm from './PostForm';
import PostDetail from './PostDetail';
import { fetchPosts, fetchPost, removePosts, updatePost } from '@/redux/actions/postActions';

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/posts',
        breadcrumbName: 'Danh sách bài viết',
    }
]

class PostList extends Component {

    constructor() {
        super();
        this.state = {
            isLoading: false,
            selectedRowKeys: [],
            isOpenAddForm: false,
            isOpenDetail: false,
            current_id: null,
            currentData: null
        }
    }

    componentDidMount() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.setState({
            isLoading: true
        });
        this.props.fetchPosts({ ...query }).finally(() => {
            this.setState({
                isLoading: false
            })
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.setState({ isLoading: true });
            this.props.fetchPosts({ ...query }).finally(() => {
                this.setState({ isLoading: false });
            })
        }
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys })
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        })
    }

    onRemove() {
        this.props.removePosts(this.state.selectedRowKeys).then(() => {
            this.setState({
                selectedRowKeys: [],
            })
            setTimeout(() => {
                Modal.destroyAll();
            }, 800)
            this.reloadData()
        })
    }

    reloadData() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.setState({
            isLoading: true
        });
        return this.props.fetchPosts({ ...query }).finally(() => {
            this.setState({
                isLoading: false
            })
        })
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }
        query = cleanObject(query);
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        })
    }

    handleCancel = () => {
        this.setState({
            visible: false,
            isOpenAddForm: false
        })
    }

    toggleOpenDetail(isOpenDetail, data = null) {
        this.setState({ isOpenDetail: isOpenDetail, currentData: data });
    }

    onDetail(id) {
        this.setState({ current_id: id })
        this.props.fetchPost(id).then(res => {
            this.toggleOpenDetail(true, res);
        })
    }

    render() {
        var {
            selectedRowKeys,
            isLoading,
            isOpenAddForm,
            isOpenDetail,
            currentData,
            current_id
        } = this.state;
        const { posts, pagination } = this.props;
        var query = qs.parse(this.props.location.search.slice(1));
        var hasSelected = selectedRowKeys.length > 0;

        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };

        const columns = [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
                width: '40px'
            },
            {
                title: 'Tiêu đề',
                dataIndex: 'title',
                key: 'title',
                width: '300px',
                render: (text, record) => {
                    return (
                        <div
                            onClick={() => checkPermission('posts', 'detail') && this.onDetail(record.id)}
                            className={checkPermission('posts', 'detail') ? 'primary-color item-action-btn' : ''}
                        >
                            <TextTruncate text={stripHtml(record.title)} line={1} truncateText="..." />
                        </div>
                    )
                }
            },
            {
                title: 'Từ khóa',
                dataIndex: 'keyword',
                key: 'keyword',
                width: '200px',
            },
            {
                title: 'Tên miền sử dụng',
                dataIndex: 'domain_used',
                key: 'domain_used',
                width: '200px',
            },
            {
                title: 'Ghi chú',
                dataIndex: 'note',
                key: 'note',
                width: '200px',
                render: (text, record) => {
                    return (
                        <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>
                            <TextTruncate text={stripHtml(record.note)} line={1} truncateText="..." />
                        </div>
                    )
                }
            },
            {
                title: 'Tình trạng',
                dataIndex: 'status',
                key: 'status',
                align: 'center',
                render: (text, record) => (
                    <div>
                        <Switch
                            checked={Boolean(record.status)}
                            disabled={!checkPermission('posts', 'update')}
                            checkedChildren="Đã hoàn thiện"
                            unCheckedChildren="Chưa hoàn thiện"
                            onChange={(value) => this.props.updatePost(record.id, { status: value }).then(() => this.reloadData())}
                        />
                    </div>
                )
            },
            {
                title: 'Ngày tạo',
                dataIndex: 'created_at',
                key: 'created_at',
                sorter: true,
                render: (text, record) => {
                    return (
                        <>{isValidDate(text)}</>
                    )
                }
            }
        ];

        var filters = [
            <BaseSelect
                key="status"
                options={[
                    { value: 1, label: 'Đã hoàn thiện' },
                    { value: 0, label: 'Chưa hoàn thiện' },
                ]}
                onChange={(value) => this.onChangeFilter("status", value)}
                placeholder="Tình trạng"
                defaultValue={query.status ? parseInt(query.status, 10) : null}
                className="w-100"
            />,
            <DatePicker
                key="start-date"
                format="DD/MM/YYYY"
                className="w-100"
                placeholder="Ngày bắt đầu"
                onChange={(value) => this.onChangeFilter("start_date", value ? moment(value).format('YYYY-MM-DD') : null)}
                defaultValue={query.start_date ? moment(query.start_date, 'YYYY-MM-DD') : null} />,
            <DatePicker
                key="end-date"
                format="DD/MM/YYYY"
                className="w-100"
                placeholder="Ngày kết thúc"
                onChange={(value) => this.onChangeFilter("end_date", value ? moment(value).format('YYYY-MM-DD') : null)}
                defaultValue={query.end_date ? moment(query.end_date, 'YYYY-MM-DD') : null} />
        ];

        return (
            <div>
                <PageTitle routes={routes} title="Danh sách bài viết" />
                <div>
                    <TableActionBar
                        isShowAddButton={checkPermission('posts', 'create')}
                        isShowDeleteButton={checkPermission('posts', 'remove')}
                        disabled={!selectedRowKeys.length ? true : false}
                        onDelete={() => this.onRemove()}
                        onAdd={() => this.setState({ isOpenAddForm: true })}
                        showSearch={true}
                        showFilter={true}
                        activeFilter={query.status || parseInt(query.status, 10)}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                        filters={filters}
                    >
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.reloadData()}>Refresh</Button>
                        {
                            hasSelected ? <span>Đang chọn {selectedRowKeys.length} bản ghi </span> : ''
                        }
                    </TableActionBar>
                </div>

                <Table
                    rowKey="id"
                    size='small'
                    tableLayout='auto'
                    columns={columns}
                    loading={isLoading}
                    dataSource={posts || []}
                    rowSelection={rowSelection}
                    pagination={{
                        pageSize: pagination.perPage,
                        current: pagination.currentPage,
                        total: pagination.total,
                        showTotal: total => `Tổng ${total} bản ghi`,
                        defaultPageSize: 30, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '40', '50', '100', '200']
                    }}
                    onChange={(pagination, filters, sorter) => this.onChangeTable(pagination, sorter)}
                    scroll={{
                        x: 'max-content'
                    }}
                />
                <PostForm
                    visible={isOpenAddForm}
                    onCancel={() => this.handleCancel()}
                    reloadData={() => this.reloadData()}
                />

                <PostDetail
                    visible={isOpenDetail}
                    currentData={currentData}
                    reloadData={() => { this.onDetail(current_id); this.reloadData() }}
                    onCancel={() => this.toggleOpenDetail(false)}
                />
            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
        posts: state.postReducer.posts,
        pagination: state.postReducer.pagination
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchPosts: filter => dispatch(fetchPosts(filter)),
        removePosts: ids => dispatch(removePosts(ids)),
        updatePost: (id, data) => dispatch(updatePost(id, data)),
        fetchPost: id => dispatch(fetchPost(id))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(PostList);
